import React from 'react';
import PropTypes from 'prop-types';

import { Container } from 'components/CardStyles';

const Card = ({ children, display, padding, shadow }) => (
  <Container
    className="block"
    display={display}
    shadow={shadow}
    padding={padding}
  >
    {children}
  </Container>
);

Card.defaultProps = {
  display: null,
  padding: '12',
  shadow: null,
};

Card.propTypes = {
  children: PropTypes.element.isRequired,
  display: PropTypes.string,
  padding: PropTypes.number,
  shadow: PropTypes.string,
};

export default Card;
